import {
  FETCH_PRODUCT_TYPES_REQUEST,
  FETCH_PRODUCT_TYPES_SUCCESS,
  FETCH_PRODUCT_TYPES_FAILURE,
  ADD_PRODUCT_TYPE_REQUEST,
  ADD_PRODUCT_TYPE_SUCCESS,
  ADD_PRODUCT_TYPE_FAILURE,
  UPDATE_PRODUCT_TYPE_REQUEST,
  UPDATE_PRODUCT_TYPE_SUCCESS,
  UPDATE_PRODUCT_TYPE_FAILURE,
  DELETE_PRODUCT_TYPE_REQUEST,
  DELETE_PRODUCT_TYPE_SUCCESS,
  DELETE_PRODUCT_TYPE_FAILURE,
  SET_PRODUCT_TYPE_EDIT,
  CLEAR_PRODUCT_TYPE_EDIT,
} from '../../../../types/masters/styles/productType/productTypeTypes';

const initialState = {
  list: [],
  loading: false,
  error: null,
  editingProductType: null,
};

const productTypeReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_PRODUCT_TYPES_REQUEST:
    case ADD_PRODUCT_TYPE_REQUEST:
    case UPDATE_PRODUCT_TYPE_REQUEST:
    case DELETE_PRODUCT_TYPE_REQUEST:
      return { ...state, loading: true, error: null };
    case FETCH_PRODUCT_TYPES_SUCCESS:
      return { ...state, loading: false, list: action.payload, error: null };
    case ADD_PRODUCT_TYPE_SUCCESS:
    case UPDATE_PRODUCT_TYPE_SUCCESS:
    case DELETE_PRODUCT_TYPE_SUCCESS:
      return { ...state, loading: false, error: null };
    case FETCH_PRODUCT_TYPES_FAILURE:
    case ADD_PRODUCT_TYPE_FAILURE:
    case UPDATE_PRODUCT_TYPE_FAILURE:
    case DELETE_PRODUCT_TYPE_FAILURE:
      return { ...state, loading: false, error: action.payload };
    case SET_PRODUCT_TYPE_EDIT:
      return { ...state, editingProductType: action.payload };
    case CLEAR_PRODUCT_TYPE_EDIT:
      return { ...state, editingProductType: null };
    default:
      return state;
  }
};

export default productTypeReducer; 